import React from "react";

import Sidebar from "../Sidebar/Sidebar";
import { DeleteIcon } from "../../../utils/Icons";
import Heading from "../../Heading/Heading";

import MaterialTable from "material-table";
import { Api } from "../../../helper/ApiList";
import { useDispatch, useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";
import { useStyles } from "../../../utils/useStyles";
import { loaderAction } from "../../../services/actions/loaderAction";
import axios from "axios";
import { useAlert } from "react-alert";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Avatar from "@mui/material/Avatar";

export default function CourierPrice() {
  const classes = useStyles();
  const { adminToken } = useSelector((state) => state.isSuperAdmin);
  const dispatch = useDispatch();
  const alert = useAlert();
  const { data, loading, fetchAgain } = useFetch(
    Api.getCourierPrices,
    adminToken,
    "get"
  );

  const deletePromoCode = async (rowData) => {
    dispatch(loaderAction(true));
    let config = {
      headers: { Authorization: `${adminToken}` },
    };

    const { data } = await axios.put(
      Api.deleteCourierPrice,
      {
        _id: rowData._id,
      },
      config
    );

    const { response } = data;
    if (response.status.statusCode === 200) {
      alert.success("Courier Price has been successfully deleted");
      fetchAgain();
    } else {
      alert.info(response.status.customMessage);
    }
    dispatch(loaderAction(false));
  };

  const columns = [
    { title: "Sr. No", field: "index" },
    { title: "Name", field: "name" },

    { title: "Charges", field: "charges" },
    { title: "Min Distance", field: "minDistance" },
    { title: "Max Distance", field: "maxDistance" },

    {
      title: "Img",
      field: "image",
      render: (item) => (
        <>
          {item.image ? (
            <LazyLoadImage
              alt={""}
              effect="blur"
              src={process.env.REACT_APP_IMAGE_URL + item.image}
              height="50"
              width="50"
            />
          ) : (
            <Avatar src="" sx={{ width: 24, height: 24 }} />
          )}
        </>
      ),
    },
    { title: "Create At", field: "createAt" },
  ];

  let tableData =
    data && data.length === 0
      ? []
      : data &&
        data.map((item, index) => {
          return {
            index: index + 1,
            _id: item?._id,
            name: item?.vehicleId?.name,
            minDistance: item?.distance?.minDistance + item?.distance?.unit,
            maxDistance: item?.distance?.maxDistance + item?.distance?.unit,
            image: item?.vehicleId?.image,
            charges: item?.vehicleId?.charges,
            createAt: item?.createdAt.slice(0, 10),
          };
        });

  const actions = [
    {
      icon: DeleteIcon,
      tooltip: "Delete Code",
      onClick: (event, rowData) => deletePromoCode(rowData),
    },
  ];

  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Heading addCourier={true} />

        <div className="mt-2">
          <MaterialTable
            options={{
              actionsColumnIndex: -1,
            }}
            data={tableData && tableData}
            columns={columns && columns}
            title=""
            onRowClick={(event, rowData) => console.log(rowData)}
            actions={actions && actions}
          />
        </div>
      </main>
    </div>
  );
}
